<template>
    <div class="row">
        <div class="col-12 d-none d-sm-block px-0">
            <ul class="qf-dashboard-navigation">
                <li class="qf-active-nav">
                    <a href="#!" @click.prevent>
                        {{fullName}}
                    </a>
                </li>
                <li></li>
            </ul>
        </div>
        <div class="col-12 pt-4 qf-fs-90">
            <strong>{{$ml.get('Profile_Information')}}</strong>
        </div>
        <div class="col-12 pt-4 small">
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 qf-m-01rem qf-bg-white d-flex align-items-center qf-h-50px">
                    <EditNameForm @saveData="saveData" ref="editNameRef"/>
                </div>
                <div class="w-50 qf-m-01rem qf-bg-white d-flex align-items-center qf-h-50px">
                    <EditEmailForm @saveData="saveData" ref="editEmailRef"/>
                </div>
            </div>
        </div>
        <div class="col-12 pt-4 small">
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-auto w-md-100 qf-m-01rem qf-bg-white d-flex align-items-center qf-h-50px">
                    <EditPasswordForm/>
                </div>
            </div>
        </div>

        <div class="col-12 pt-5 qf-fs-90 d-flex" v-if="hasBillingInfo">
            <div class="w-100">
                <strong>{{$ml.get('billing')}}</strong>
            </div>
        </div>

        <div class="col-12 pt-4 small" v-if="hasBillingInfo">
            <div class="w-100 d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 qf-m-01rem qf-bg-white d-flex align-items-center qf-h-50px">
                    <EditCompanyForm @saveData="saveData" ref="editCompanyRef"/>
                </div>
                <div class="w-50 qf-m-01rem qf-bg-white d-flex align-items-center qf-h-50px">
                    <EditVatForm @saveData="saveData" ref="editVatRef"/>
                </div>
            </div>
            <div class="w-100 d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 qf-m-01rem qf-bg-white d-flex align-items-center qf-h-50px">
                    <EditCityForm @saveData="saveData" ref="editCityRef"/>
                </div>
                <div class="w-50 qf-m-01rem qf-bg-white d-flex align-items-center qf-h-50px">
                    <EditCountryForm @saveData="saveData" ref="editCountyRef"/>
                </div>
            </div>
            <div class="w-100 d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-auto w-md-100 qf-m-01rem qf-bg-white d-flex align-items-center qf-h-50px">
                    <EditAddressForm @saveData="saveData" ref="editAddressRef"/>
                </div>
            </div>
        </div>

        <!--        <div class="col-12" v-if="isMainUser">-->
        <!--            <div class="row">-->
        <!--                <div class="col-12 pt-5">-->
        <!--                    <div class="table-responsive">-->
        <!--                        <table class="table qf-table text-center qf-line-height-1-25 qf-fs-90">-->
        <!--                            <thead>-->
        <!--                            <tr>-->
        <!--                                <th>-->
        <!--                                    {{$ml.get('Plan')}}-->
        <!--                                </th>-->
        <!--                                <th>-->
        <!--                                    {{$ml.get('Valid_To')}}-->
        <!--                                </th>-->
        <!--                                <th>-->
        <!--                                    {{$ml.get('Download_invoice')}}-->
        <!--                                </th>-->
        <!--                            </tr>-->
        <!--                            </thead>-->
        <!--                            <tbody>-->
        <!--                            <tr class="qf-h-50px">-->
        <!--                                <td class="py-2 w-25 position-relative">-->
        <!--                                    <span class="qf-plan-bullet">{{ planName }}</span>-->
        <!--                                </td>-->
        <!--                                <td class="py-2 w-25">-->
        <!--                                    {{ validTo }}-->
        <!--                                </td>-->
        <!--                                <td class="py-2 w-25">-->
        <!--                                    Test_change_this <a href="#!">-->
        <!--                                    <font-awesome-icon icon="download"/>-->
        <!--                                </a>-->
        <!--                                </td>-->
        <!--                            </tr>-->
        <!--                            </tbody>-->
        <!--                        </table>-->
        <!--                    </div>-->
        <!--                </div>-->

        <!--                <div class="col-12 pt-2 qf-fs-90 d-flex">-->
        <!--                    <div class="w-100 text-right">-->
        <!--                        <button type="button" class="btn btn-outline-dark qf-fs-90 text-uppercase"-->
        <!--                                @click="openExtendPlan">-->
        <!--                            {{$ml.get('Extend_plan')}}-->
        <!--                        </button>-->
        <!--                        <button type="button" class="btn btn-outline-dark qf-fs-90 text-uppercase ml-4">-->
        <!--                            {{$ml.get('Cancel_plan')}}-->
        <!--                        </button>-->
        <!--                        <router-link :to="{name: 'UpgradePlan'}"-->
        <!--                                     v-if="planId !== 3"-->
        <!--                                     class="btn btn-warning qf-fs-90 text-uppercase ml-4">-->
        <!--                            {{$ml.get('Upgrade_plan')}}-->
        <!--                        </router-link>-->
        <!--                    </div>-->
        <!--                </div>-->

        <!--                <div class="col-12 pt-2 qf-extend-plan-wrapper" v-if="extendPlanView">-->
        <!--                    <div class="row">-->
        <!--                        <div class="col-12 text-right qf-cursor-pointer"-->
        <!--                             @click="closeExtendPlan">-->
        <!--                            <font-awesome-icon icon="times"/>-->
        <!--                        </div>-->
        <!--                        <div class="col-12 text-center">-->
        <!--                            <h3 class="text-uppercase pb-3">{{$ml.get('Extend_current_plan')}}</h3>-->
        <!--                        </div>-->
        <!--                        <div class="col-6 d-flex justify-content-center align-items-center text-center">-->
        <!--                            <div class="d-flex justify-content-center">-->
        <!--                                <Plan class="qf-no-hover" :plan="$store.state.plans[planIndex]"-->
        <!--                                      v-if="$store.state.plans.length">-->
        <!--                                    <div class="d-flex">-->
        <!--                                        <div class="col text-left h4 pb-0">-->
        <!--                                            {{$ml.get('TOTAL')}}:-->
        <!--                                        </div>-->
        <!--                                        <div class="col text-right h4 pb-0">-->
        <!--                                            ${{$store.state.plans[planIndex].yearly_price}}-->
        <!--                                        </div>-->
        <!--                                    </div>-->
        <!--                                </Plan>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                        <div class="col-5 d-flex justify-content-center align-items-center">-->
        <!--                            <div class="d-flex justify-content-center">-->
        <!--                                <ExtendPlan @closeExtendPlan="closeExtendPlan" @updateUserData="updateUserData"/>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->

        <!--            </div>-->
        <!--        </div>-->

    </div>
</template>

<script>
    import EditNameForm from './EditNameForm'
    import EditEmailForm from './EditEmailForm'
    import EditCompanyForm from './EditCompanyForm'
    import EditCountryForm from './EditCountryForm'
    import EditAddressForm from './EditAddressForm'
    import EditVatForm from './EditVatForm'
    import EditCityForm from './EditCityForm'
    import EditPasswordForm from './EditPasswordForm'
    import ExtendPlan from './ExtendPlan'

    export default {
        name: 'EditLoggedUser',
        components: {
            ExtendPlan,
            EditNameForm,
            EditEmailForm,
            EditCompanyForm,
            EditCountryForm,
            EditAddressForm,
            EditVatForm,
            EditCityForm,
            EditPasswordForm
        },
        computed: {
            hasBillingInfo() {
                return this.$store.state.loggedUser.billing_info;
            },
            isMainUser() {
                return this.$store.state.loggedUser.roles[0] === 'ROLE_MAIN';
            },
            planId() {
                return this.$store.state.loggedUser.plan.id;
            },
            planName() {
                return this.$store.state.loggedUser.plan.name;
            },
            validTo() {
                return this.$options.filters.dateFormat(this.$store.state.loggedUser.valid_to);
            },
            fullName() {
                return `${this.$store.state.loggedUser.first_name} ${this.$store.state.loggedUser.last_name}`
            }
        },
        data() {
            return {
                userRoles: [],
                planIndex: 2,
                extendPlanView: false,
                plans: {}
            }
        },
        beforeMount() {

        },
        mounted() {
            this.$store.dispatch('plans').then(response => {
                this.plans = response;
            });
        },
        methods: {
            saveData(fields, type, referencedComponent) {
                let data = {...this.$store.state.loggedUser, ...fields};
                let self = this;

                this.$store.dispatch('editLoggedUser', data).then(() => {
                    if (type && referencedComponent) {
                        self.$refs[referencedComponent]['closeEdit' + type]();
                    }
                });
            },
            openExtendPlan() {
                let that = this;
                this.plans.forEach((plan, index) => {
                    if (plan.id === that.$store.state.loggedUser.plan.id) {
                        that.planIndex = index;
                    }
                });
                this.extendPlanView = true;
            },
            closeExtendPlan() {
                this.extendPlanView = false;
            },
            updateUserData(newData) {
                this.$store.commit('setLoggedUser', newData);
            }
        }
    }
</script>

<style scoped>
    .qf-plan-bullet:before {
        content: ' ';
        width: 10px;
        height: 10px;
        position: absolute;
        left: 20px;
        top: 20px;
        border-radius: 50%;
        background-color: #F6BF00;
    }

    .qf-extend-plan-wrapper {
        margin-top: 50px;
        padding: 10px;
        border: 1px solid darkgray;
        border-radius: 10px;
    }

    .qf-bg-white.w-50 {
        width: auto !important;
    }

    @media (min-width: 576px) {
    }

    @media (min-width: 768px) {
        .qf-bg-white.w-50 {
            width: 50% !important;
        }

        .w-md-100 {
            width: 100%!important;
        }
    }
</style>
